import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TypeOther = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const type = useWatch({ control, name: `institutionActivitiesInfo.${index as 0}.type` })

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.typeOther`}
      control={control}
      rules={{
        validate: (value) => (type === 'Other' ? Validators.required.field(value) : undefined)
      }}
      render={({ field }) => (
        <FF2
          required={type === 'Other'}
          field={field}
          label="Other"
          input={(props) => <TextInput {...props} disabled={type !== 'Other'} />}
        />
      )}
    />
  )
}
